import React from "react";
import { useRouter } from "next/navigation";
import Image from "next/image";
import { DesCard, NormalStyles, TitleCard } from "@/layouts/styles/ssr.style";
import { BiUser } from "react-icons/bi";
import { Popover } from "antd";
import { definitions } from "@/services/metruyenvl";
import { Constants } from "@/types/constants";

function SliderShowCardAuthor({ book }: { book?: definitions["do.BookDO"] }) {
    const router = useRouter();
    return (
        <div
            className="h-52 w-full grid gap-x-4 cursor-pointer"
            onClick={() => {
                router.push(`/truyen/${book?.slug}`);
            }}
            style={{ gridTemplateColumns: "0.6fr 1fr" }}
        >
            <div className="flex justify-center md:w-[150] md:h-[200] overflow-hidden">
                <Image src={book?.thumbnail ?? Constants.DefaultBookThumbnail} width={150} height={150} alt="" className="md:w-[150px] md:h-[200px] object-cover" />
                {/* <img src={book?.thumbnail ?? Constants.DefaultBookThumbnail} alt="" className="md:w-[150px] md:h-[200px] object-cover" /> */}
                {/* <Image src={book?.thumbnail ?? Constants.DefaultBookThumbnail} alt="" width={150} height={200}  className="md:w-[150] md:h-[200] object-cover" /> */}
            </div>
            <div className="">
                <TitleCard>{book?.name}</TitleCard>
                <div className="flex items-center gap-x-1 mt-2">
                    {" "}
                    <BiUser color={"#948f8c"} />
                    <NormalStyles>
                        <Popover content={book?.author?.name} placement="top">
                            {book?.author?.name}
                        </Popover>
                    </NormalStyles>
                </div>
                <div className="line-clamp-5 text-xs text-gray-500 mt-2">{book?.description}</div>
            </div>
        </div>
    );
}

export default SliderShowCardAuthor;
